import { first } from 'rxjs/operators';
import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';

@inheritSerialization(AbstractModel)
export class Person extends AbstractModel {
  @autoserialize
  firstName: string;

  @autoserialize
  middleName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  hasMiddleName: boolean;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  smsEnabledPhone: boolean;

  @autoserialize
  emailAddress: string;

  @autoserialize
  emailVerified: boolean;

  @autoserialize
  emailOptedOut: boolean;

  @autoserialize
  currentLatitude: number;

  @autoserialize
  currentLongitude: number;

  @autoserialize
  uzurvCode: string;

  @autoserialize
  referrerPersonId: number;

  @autoserialize
  referralCode: string;

  @autoserialize
  profileImage: string;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }

  static OnSerialized(instance: Person, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = DateUtil.serializeLocalDate(instance.dateOfBirth);
    }

    if (!isNullOrUndefined(instance.firstName)) {
      json.firstName = instance.firstName.trim();
    }

    if (!isNullOrUndefined(instance.middleName)) {
      json.middleName = instance.middleName.trim();
    }

    if (!isNullOrUndefined(instance.lastName)) {
      json.lastName = instance.lastName.trim();
    }

    if (!isNullOrUndefined(instance.emailAddress)) {
      json.emailAddress = instance.emailAddress.toLowerCase().trim();
    }

    if (!isNullOrUndefined(instance.referralCode)) {
      instance.referralCode = instance.referralCode.trim();

      if (instance.referralCode.trim().length === 0) {
        json.referralCode = null;
      } else {
        json.referralCode = instance.referralCode.toUpperCase();
      }
    }
  }

  static OnDeserialized(instance: Person, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = DateUtil.deserializeLocalDate(json['dateOfBirth']);
    }
  }
}
